<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary mr-1"
        pill
        @click="createQRCode"
        v-if="hasPermission('create_qr_code')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Generate QR</span>
      </b-button>

      <b-button variant="outline-success" pill size="md" @click="printAllQRImages">
        Print All QR Codes
      </b-button>

    </div>

    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="site"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building"
              label-for="building"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building"
                placeholder="Select Building"
                :options="buildings"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Flat"
              label-for="flat"
              class="w-50"
              v-if="searchType.value === 3"
            >
              <v-select
                label="name"
                v-model="flat"
                placeholder="Select Flat"
                :options="flats"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Floor"
              label-for="floor"
              class="w-50"
              v-if="searchType.value === 4"
            >
              <v-select
                label="name"
                v-model="floor"
                placeholder="Select Floor"
                :options="floors"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="qr_codes"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_qr_code')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(building_data)="row">
          {{
            row.item.building_data ? row.item.building_data.name : ""
          }}
        </template>


        <template #cell(floor_data)="row">
          {{
            row.item.floor_data ? row.item.floor_data.floor_no : ""
          }}
        </template>


        <template #cell(flat_data)="row">
          {{
            row.item.flat_data ? row.item.flat_data.flat_no : "No Flat Assigned"
          }}
        </template>

        <template #cell(qr_code_image)="row">
          <img
            :src="row.item.qr_code_image"
            alt="QR Image"
            style="width: 100px; height: auto"
          />
        </template>
        
        
        <template #cell(manage)="row">
          <b-button
            variant="outline-success"
            pill
            size="sm"
            class="mr-50"
            @click="downloadImage(row.item.qr_code_image)"
            v-if="hasPermission('show_qr_code')"
          >
            Download
          </b-button>
        </template>
      </b-table>
      <b-pagination
        size="md"
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
      ></b-pagination>
    </b-card>
    <CreateQRCodeModal
      @modalClosed="onModalClosed"
      :key="`create-${createQRCodeModalCount}`"
    />
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateQRCodeModal from "@/components/qr_code/CreateQRCodeModal.vue";
import util from "@/util.js";


export default {
  components: {
    CreateQRCodeModal,
    VueSelectPaginated,
  },
  data() {
    return {
      fields: [
        { key: "qr_code_image", label: "QR Code" },
        { key: "site_data", label: "Site"},
        { key: "building_data", label: "Building"},
        { key: "floor_data", label: "Floor"},
        { key: "flat_data", label: "Flat"},
        { key: "manage", label: "Actions"},
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      qr_codes: [],
      qr_codes_list: [],
      qr_code: null,
      createQRCodeModalCount: 0,
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building" },
        { value: 3, name: "Flat" },
        { value: 4, name: "Floor" },
      ],
      searchType: null,
      name: "",
      counts : "",
      sites : [],
      buildings: [],
      flats: [],
      floors: [],
      site : "",
      building : "",
      flat : "",
      floor : "",
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();

    const sites = await this.getSitesDDL();
    this.sites = sites.data;

    const buildings = await this.getBuildingsDDL();
    this.buildings = buildings.data;

    const flats = await this.getFlatsDDL();
    this.flats = flats.data;

    const floors = await this.getFloorsDDL();
    this.floors = floors.data;

    
  },
  methods: {
    ...mapActions({
      getQRCodes: "appData/getQRCodes",
      getQRCodesDDL: "appData/getQRCodesDDL",
      getFlatsDDL: "appData/getFlatsDDL",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building = "";
            this.flat = "";
            this.floor = "";
            break;
          case 2:
            this.site = "";
            this.flat = "";
            this.floor = "";
            break;
          case 3:
            this.site = "";
            this.building = "";
            this.floor = "";
            break;
          case 4:
            this.site = "";
            this.building = "";
            this.flat = "";
            break;          
        }
      } else {
        this.site = "";
        this.building = "";
        this.flat = "";
        this.floor = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getQRCodes({
          pageNumber: this.currentPage,      
          site: this.site,      
          building: this.building,      
          flat: this.flat,
          floor: this.floor,
        });
        this.qr_codes = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;

        const qrs = await this.getQRCodesDDL();
        this.qr_codes_list = qrs.data;
      } catch (error) {
        this.displayError(error);
      }
    },
    downloadImage(imageUrl) {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = 'qr_code_image'; 
      link.click();
    },
    createQRCode() {
      this.createQRCodeModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-qr-code-modal");
      });
    },
    
    async removeQRCode(qr_code) {
      this.qr_code = qr_code;
      try {
        const res = await this.deleteQRCode({
          pk: this.qr_code.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "QRCode deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },

    printAllQRImages() {
      const qrImagesHtml = this.qr_codes_list
        .map(
          (qrCode) =>
            `<div class="qr-container"><img src="${qrCode.qr_code_image}" alt="QR Code" /></div>`
        )
        .join("");

      const printWindow = window.open("", "Print QR Codes", "height=600,width=800");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Codes</title>
            <style>
              @page {
                size: A4;
                margin: 0;
              }
              body {
                margin: 0;
                padding: 1cm;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
              }
              .qr-container {
                width: 50%;
                box-sizing: border-box;
                padding: 1cm;
                display: flex;
                justify-content: center;
                align-items: center;
                page-break-inside: avoid;
              }
              img {
                width: 100%;
                max-width: 10cm; /* Adjust this size to fit within your desired print dimensions */
                height: auto;
              }
            </style>
          </head>
          <body>${qrImagesHtml}</body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      // printWindow.print();
      // printWindow.close();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
